import $ from 'jquery';
import { said,appUrl } from '../../AppConfig';
import { errorValidataion } from '../actions/sessions';
import { download } from './download';
//import summary from './summary.json'

//var GRinput = '';
//var summary = '';

const canceled = {};
const EZMERAL_SOLUTION_NAME = "HPE Ezmeral Container Platform Configuration";
const BLUE_DATA = 'BlueData';

const apiMiddleware = ({ dispatch }) => (next) => (action) => {

  const handleResponse = (data) => {

    if(action.payload.next.SUCCESS === 'FETCH_SOLUTION_ADVANCED_SUCCESS')
    {           
      if(data.status==='Error')
      {
        dispatch({ type: action.payload.next.ERROR, payload: data })
      }else{
        window.location.replace(data);
      }
      
    //       $.ajax({
    //       type: 'POST',
    //       url: 'http://15.213.141.57:8080/UsherAPI/rest/ecoSystem/pushBomAndSolutionDetails',
    //       dataType: 'json',
    //       contentType: 'application/json; charset=utf-8',
    //       data: JSON.stringify(data),          
    //       success: function (response){
    //            console.log(response);
    //            dispatch({ type: 'POSTSSET_SUCCESS',payload: response}); 
    //       },
    //       error: function (response){            
    //         dispatch({ type: 'SERVER_ERROR', payload: response })
    //       }
    //     });
    //      dispatch({ type: 'POSTSSET_PENDING',payload:'Waiting for SSET...'});
     }    

    if (action.cancelable && canceled[action.cancelable]) {
      return;
    }

    if (action.payload.next.SUCCESS === 'EPA_DOWNLOAD_METRICS_SUCCESS') {
      download(data, "MetricsData.xls", "text/html");
      return;
    }

    if (action.payload.next.SUCCESS === 'EPA_EXPORT_COMPARESOLUTIONDATA_SUCCESS') {
      download(data, "CompareSolutionData.xls", "text/html");
      return;
    }


    if (data.isError && action.payload.next.ERROR === 'VALIDATE_WORKLOAD_ERROR') {
      let obj = { isError: true, errorMsg: data.Message };
      dispatch(errorValidataion(obj));
    }
    else if (action.payload.next.ERROR === 'VALIDATE_WORKLOAD_ERROR' && !data.isError) {
      let obj = '';
      dispatch(errorValidataion(obj));
    }

    if (data === 'WORKLOAD_CONFLICT') {
      dispatch({ type: 'WORKLOAD_CONFLICT', payload: data })
    }
    else if (data === 'SOLUTION_CONFLICT') {
      dispatch({ type: 'SOLUTION_CONFLICT', payload: data })
    } else if ((said === "EPA" || said === "EPAvNext") && action.payload.next.SUCCESS === 'LOAD_SELECTION_SUCCESS' && !data.isFailed) {
      if (data.Workload.UserInputs.Environments.WorkloadType === BLUE_DATA) {
        if (!Array.isArray(data.Workload.UserInputs.Environments.Environment)) {
          // return dispatch({ type: 'LOADED_OLD_SELECTION'});
        }
      }
      if (data.TreeView !== null && data.TreeView !== '' && Array.isArray(data.TreeView.Solutions.Solution)) {
        // let toReducer = '';
        let multipleSolutions = [];
        let WdoConfiguration = { GRBomInput: '', GRInput: '', bomView: '', configView: '', treeView: '' }
        let Traditional = { GRBomInput: '', GRInput: '', bomView: '', configView: '', treeView: '' }
        let EzmeralCPSolutions = { GRBomInput: '', GRInput: '', bomView: '', configView: '', treeView: '' }

        multipleSolutions = data.TreeView.Solutions.Solution.map((item,index) => {
          if (item.SolProfile['#text'] == 'Elastic Config') {
            let temp = JSON.parse(JSON.stringify(data));
            temp.TreeView.Solutions.Solution = item;
            WdoConfiguration.treeView = temp.TreeView;            
            return {...WdoConfiguration}
          }
          else if (item.SolProfile['#text'] == 'Traditional') {
            let temp = JSON.parse(JSON.stringify(data));
            temp.TreeView.Solutions.Solution = item;
            Traditional.treeView = temp.TreeView;
            return Traditional;
          }
          else if (item.SolProfile['#text'] === EZMERAL_SOLUTION_NAME) {
            let temp = JSON.parse(JSON.stringify(data));
            temp.TreeView.Solutions.Solution = item;
            EzmeralCPSolutions.treeView = temp.TreeView;
            return {...EzmeralCPSolutions}
          }
        });

        data.TreeView = multipleSolutions[0].treeView;
        data.EPAArray = multipleSolutions;

        dispatch({ type: 'LOAD_SELECTION_SUCCESS', payload: data })
      }
      else {
        dispatch({ type: 'LOAD_SELECTION_SUCCESS', payload: data })
      }
    }
    else if ((said === "EPA" || said === "EPAvNext") && action.payload.next.SUCCESS === 'FETCH_SOLUTION_SUCCESS' && !data.isFailed) {
      let multipleSolutions = [];
      let WdoConfiguration = { GRBomInput: '', GRInput: '', bomView: '', configView: '', treeView: '' }
      let Traditional = { GRBomInput: '', GRInput: '', bomView: '', configView: '', treeView: '' }
      let EzmeralCPSolutions = { GRBomInput: '', GRInput: '', bomView: '', configView: '', treeView: '' }

      // let arr = [];

      // if( action.payload.next.SUCCESS === 'LOAD_SELECTION_SUCCESS' ){

      //     arr = data.TreeView.Solutions.Solution;

      //     if(Array.isArray(arr))        
      //     {
      //       let toReducer = '';

      //       multipleSolutions = arr.map((item)=>{
      //         if(item.SolProfile['#text']== 'WDO Config')
      //         {
      //           var temp = JSON.parse(JSON.stringify(data.TreeView));
      //           temp.Solutions.Solution = item;
      //           WdoConfiguration.treeView = temp;
      //           toReducer = WdoConfiguration;
      //           return WdoConfiguration;
      //         }
      //         else if (item.SolProfile['#text']== 'Traditional')
      //         {
      //           var temp = JSON.parse(JSON.stringify(data.TreeView));
      //           temp.Solutions.Solution = item;
      //           Traditional.treeView = temp;
      //           return Traditional;
      //         }
      //       });

      //       var obj = {
      //       data: toReducer.treeView,
      //       multipleSolutions
      //       }

      //       dispatch({ type: 'EPA_MULTIPLE_SOLUTIONS_SUCCESS', payload: obj })
      //     }
      //     else{
      //       dispatch({ type: action.payload.next.SUCCESS, payload: data })
      //     }
      // }else if( action.payload.next.SUCCESS === 'FETCH_SOLUTION_SUCCESS'){

      //     arr = data.Solutions.Solution;

      //     if(Array.isArray(arr))        
      //     {
      //       let toReducer = '';

      //       multipleSolutions = arr.map((item)=>{
      //         if(item.SolProfile['#text']== 'WDO Config')
      //         {
      //           var temp = JSON.parse(JSON.stringify(data));
      //           temp.Solutions.Solution = item;
      //           WdoConfiguration.treeView = temp;
      //           toReducer = WdoConfiguration;
      //           return WdoConfiguration;
      //         }
      //         else if (item.SolProfile['#text']== 'Traditional')
      //         {
      //           var temp = JSON.parse(JSON.stringify(data));
      //           temp.Solutions.Solution = item;
      //           Traditional.treeView = temp;
      //           return Traditional;
      //         }
      //       });

      //       var obj = {
      //       data: toReducer.treeView,
      //       multipleSolutions
      //       }

      //       dispatch({ type: 'EPA_MULTIPLE_SOLUTIONS_SUCCESS', payload: obj })
      //     }
      //     else{
      //       dispatch({ type: action.payload.next.SUCCESS, payload: data })
      //     }
      // }

      if (Array.isArray(data.Solutions.Solution)) {
        // let toReducer = '';

        multipleSolutions = data.Solutions.Solution.map((item,index) => {
          if (item.SolProfile['#text'] == 'Elastic Config') {
            let temp = JSON.parse(JSON.stringify(data));
            temp.Solutions.Solution = item;
            WdoConfiguration.treeView = temp;
  
            return {...WdoConfiguration}
          }
          else if (item.SolProfile['#text'] == 'Traditional') {
            let temp = JSON.parse(JSON.stringify(data));
            temp.Solutions.Solution = item;
            Traditional.treeView = temp;
            return Traditional;
          }
          else if (item.SolProfile['#text'] === EZMERAL_SOLUTION_NAME) {
            let sizingResult = JSON.parse(JSON.stringify(data));
            sizingResult.Solutions.Solution = item;
            EzmeralCPSolutions.treeView = sizingResult;
            return {...EzmeralCPSolutions}
          }
        });

        let obj = {
          data: multipleSolutions[0].treeView,
          multipleSolutions
        }

        dispatch({ type: 'EPA_MULTIPLE_SOLUTIONS_SUCCESS', payload: obj })
      }
      else {
        dispatch({ type: action.payload.next.SUCCESS, payload: data })
      }
    }
    else if (action.payload.next.SUCCESS === 'FETCH_SOLUTION_SUCCESS' && data.isFailed) {
      dispatch({ type: 'FETCH_SOLUTION_ERROR', payload: data });
    } //else if (action.payload.next.SUCCESS === 'FETCH_SOLUTION_SUCCESS'){      
    //  dispatch({ type: action.payload.next.SUCCESS, payload: summary })
    // }
    // else if (action.payload.next.SUCCESS === 'FETCH_GR_INPUT_SUCCESS')
    //   {
    //     dispatch({ type: action.payload.next.SUCCESS, payload: GRinput })
    //   }
    else {
      dispatch({ type: action.payload.next.SUCCESS, payload: data })
    }

  };

if(action.type === 'API_REQUEST_BLOB')
{
   let antiForgeryTokenField = document.getElementById('__antiForgeryToken');
   fetch(action.payload.url, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache': 'no-cache',
        'CSRFToken':antiForgeryTokenField.value
      },
      credentials: 'same-origin'
    })
      .then((response) => response.blob())
      .then((data)=>{
        dispatch({ type: action.payload.next.SUCCESS });
        download(data, action.payload.fileName, "text/html");        
      });
      
    dispatch({ type: action.payload.next.PENDING });
}

if(action.type === 'API_REQUEST_POST_BLOB')
{
   let antiForgeryTokenField = document.getElementById('__antiForgeryToken');
   fetch(action.payload.url, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache': 'no-cache',
        'CSRFToken':antiForgeryTokenField.value
      },
      credentials: 'same-origin',
      body : JSON.stringify(action.payload.data)
    })
      .then((response) => response.blob())
      .then((data)=>{
        dispatch({ type: action.payload.next.SUCCESS });
        download(data, action.payload.fileName, "text/html");        
      });
      
    dispatch({ type: action.payload.next.PENDING });
}

  if (action.type === 'API_REQUEST') {
    let antiForgeryTokenField = document.getElementById('__antiForgeryToken');
    fetch(action.payload.url, {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache': 'no-cache',
        'CSRFToken':antiForgeryTokenField.value
      },
      credentials: 'same-origin'
    })
      .then((response) => response.json())
      .then(handleResponse);

    dispatch({ type: action.payload.next.PENDING });
  }

  if (action.type === 'API_REQUEST_POST') {

    let antiForgeryTokenField = document.getElementById('__antiForgeryToken');

    var header = null;

    if (antiForgeryTokenField != null) {
      header = {
        'CSRFToken': antiForgeryTokenField.value //  XSRF-TOKEN
      }
    }

    $.ajax({
      type: 'POST',
      url: action.payload.url,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(action.payload.data),
      headers: header,
      success: function (response) {
        // if (action.payload.url.indexOf('AdvancedSizing')) {
        //   console.log('Inside redirect')

        //   console.log(response.redirect);
        //   window.location.replace(response)

        // }
        // else {
          console.log('Outside Inside redirect')
          handleResponse(response);
        //}
      },
      error: function (response) {
        if(action.payload.url.indexOf('GetSSETData')!==-1)
        {
          window.location.replace(appUrl);
        }
        dispatch({ type: 'SERVER_ERROR', payload: response })
      }
    });

    // fetch(action.payload.url,{
    //     method: 'POST',
    //     dataType: 'json',
    //     contentType: 'application/json',
    //     body: JSON.stringify(action.payload.data)
    // })
    // .then((response) => response.json())
    // .then(handleResponse);    
    action.payload.data!==undefined && action.payload.data.isSizerAsEntry ? 
    dispatch({ type: action.payload.next.PENDING,payload:{"isSizerAsEntry":true}})
    : 
    dispatch({ type: action.payload.next.PENDING })    
  }

  if (action.type === 'CANCEL_API_REQUEST') {
    canceled[action.id] = true;
    setTimeout(() => delete canceled[action.id], 5000);
  }


  return next(action);
};

export default apiMiddleware;



// WEBPACK FOOTER //
// ./src/State/middlewares/api.js